export default {
  init() {
    jQuery(function(){
      jQuery('.slick').slick({
        infinite: false,
        mobileFirst: true,
        arrows: false,
      });

      $('.button-prev').click(function() {
        $('.slick').slick('slickPrev');
      });
    
      $('.button-next').click(function() {
        console.log('tata');
        $('.slick').slick('slickNext');
      });

      jQuery(window).scroll(function(){
        let scrollPos = jQuery(document).scrollTop();
        let navbar = jQuery('nav.navbar');
        if(scrollPos > 0)
        {
          navbar.addClass('is-stuck');
        }
        else
        {
          navbar.removeClass('is-stuck');
        }
      });

      jQuery('#nav-icon').on('click', function() {
        jQuery("html, body").animate({ scrollTop: 0 }, 250);
      })
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js